/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StateOfGoods = {
    New: 'New',
    Used: 'Used'
} as const;
export type StateOfGoods = typeof StateOfGoods[keyof typeof StateOfGoods];


export function instanceOfStateOfGoods(value: any): boolean {
    for (const key in StateOfGoods) {
        if (Object.prototype.hasOwnProperty.call(StateOfGoods, key)) {
            if (StateOfGoods[key as keyof typeof StateOfGoods] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StateOfGoodsFromJSON(json: any): StateOfGoods {
    return StateOfGoodsFromJSONTyped(json, false);
}

export function StateOfGoodsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateOfGoods {
    return json as StateOfGoods;
}

export function StateOfGoodsToJSON(value?: StateOfGoods | null): any {
    return value as any;
}

export function StateOfGoodsToJSONTyped(value: any, ignoreDiscriminator: boolean): StateOfGoods {
    return value as StateOfGoods;
}

